// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"a1b9bd1c","145":"3c229b3d","165":"64185553","408":"3c229b3d","781":"3c229b3d"}[chunkId] + ".chunk.css";
};